import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import GridActions from 'components/GridActions'
import Button from 'components/Button'
import Icon from 'components/Icon'
import { selectFilters, selectDisplayedColumns, setDisplayedColumns, selectTotalBusinesses } from 'store/businesses'
import { searchableColumns, toggleableColumns } from 'containers/Businesses/specs'
import messages from './messages'
import styles from './BusinessesActions.scss'

function BusinessesActions({
  intl,
  onFieldsChange,
  search,
  setSearch,
  searchFields,
  setSearchFields,
  onSearch,
  onDisplayMap,
  onExport,
  isShareDisabled,
  showMap,
}) {
  const dispatch = useDispatch()

  const filters = useSelector(selectFilters)
  const displayedColumns = useSelector(selectDisplayedColumns)
  const totalBusinesses = useSelector(selectTotalBusinesses)

  const onToggleColumns = selections => {
    const nextColumns = selections.map(selection => selection.value)
    dispatch(setDisplayedColumns({ columns: nextColumns }))
  }

  return (
    <GridActions
      filters={filters}
      search={search}
      setSearch={setSearch}
      searchFields={searchFields}
      setSearchFields={setSearchFields}
      onSearch={onSearch}
      searchableFields={searchableColumns.map(column => ({
        value: column,
        label: intl.formatMessage(messages.searchableFields[column]),
      }))}
      onFieldsChange={onFieldsChange}
      allColumns={toggleableColumns.map(column => ({
        value: column,
        label: intl.formatMessage(messages.columns[column]),
      }))}
      displayedColumns={displayedColumns}
      onColumnsChange={totalBusinesses > 0 ? onToggleColumns : () => {}}
      withShare
      onShare={onExport}
      isShareDisabled={isShareDisabled}
      isReducedSearchSize={showMap}
      removeColumnsPicker
    >
      {!showMap && (
        <Button buttonType='primary' onClick={onDisplayMap} className={styles.showMap}>
          <Icon name='map' size='regular'>
            <FormattedMessage {...messages.actions.showMap} />
          </Icon>
        </Button>
      )}
    </GridActions>
  )
}

BusinessesActions.propTypes = {
  onFieldsChange: PropTypes.func.isRequired,
  search: PropTypes.string.isRequired,
  setSearch: PropTypes.func.isRequired,
  searchFields: PropTypes.array.isRequired,
  setSearchFields: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onDisplayMap: PropTypes.func.isRequired,
  onExport: PropTypes.func.isRequired,
  isShareDisabled: PropTypes.bool.isRequired,
  showMap: PropTypes.number,
}

export default injectIntl(BusinessesActions)
